import { useCallback } from 'react';

import { StringIndexedObject } from '@kanda-libs/ks-component-ts';
import { useToast } from '@kanda-libs/ks-design-library';
import {
  type RedirectURLs,
  type Service,
  services,
  useSubmit,
} from '@kanda-libs/ks-frontend-services';

import { serviceConvert } from 'utils';

export type GetCheckoutUrlCallback = (() => void) | null;

export interface GetCheckoutUrlHook {
  getLinks: (id?: string, callback?: GetCheckoutUrlCallback) => void;
  links?: StringIndexedObject;
  isSubmitting: boolean;
}

export default function useGetCheckoutUrl(): GetCheckoutUrlHook {
  const {
    submit: getCheckoutUrls,
    data: links,
    isSubmitting,
  } = useSubmit(serviceConvert(services.job.jobCheckoutLink));

  const { showError } = useToast();

  const getLinks = useCallback(
    (id?: string, callback: GetCheckoutUrlCallback = null) => {
      if (!id) return;
      getCheckoutUrls({ params: { id } }).then(({ error }) => {
        if (error) {
          const { message } = error as StringIndexedObject<string>;
          showError(message || 'Error with request');
        }
        if (callback) {
          callback();
        }
      });
    },
    [getCheckoutUrls, showError],
  );

  return {
    getLinks,
    links,
    isSubmitting: isSubmitting || false,
  };
}
